export default __webpack_public_path__ + "static/plate-9d960c4f23a1230d42e638641c414320.png";